import React from 'react';
import AlertConfigTable from './AlertConfigTable';
import PageTitle from '../headers/PageTitle';

const AlertConfigurationsRoute: React.FC = () => {
  return (
    <div className="p-4 pt-0">
      <PageTitle title={'Alert Configurations'} />
      <p className="text-muted mb-4">
        Alert Configurations define how to monitor and respond to specific
        events. Each configuration includes the event type, monitoring
        frequency, trigger conditions, and the Critical Information Requirements
        (CIRs) needed for the SITREP.
      </p>
      <AlertConfigTable />
    </div>
  );
};

export default AlertConfigurationsRoute;
